import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { LoginType } from '../../enums/login-type';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginName = 'LOGIN';
  loginTypes = LoginType;
  type = 1145;
  @ViewChild('accessControlLogin', { static: true}) accessControlLogin: ElementRef<HTMLElement>;
  @ViewChild('hospitalityLogin', { static: true}) hospitalityLogin: ElementRef<HTMLElement>;
  @ViewChild('skyAccessLogin', { static: true}) skyAccessLogin: ElementRef<HTMLElement>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.dataService.hideFooter.next(false);
    this.activatedRoute.paramMap.subscribe(paramMap => {
      var param = paramMap.get('type');
      if(param) {
        var loginType = parseInt(param);
        this.type = loginType;
        if(loginType == this.loginTypes.LOGIN) {
          this.loginName = 'LOGIN';
        }
        else if(loginType == this.loginTypes.ACCESS_CONTROL_LOGIN) {
          this.loginName = 'ACCESS CONTROL';
        }
        else if(loginType == this.loginTypes.HOSPITALITY_LOGIN) {
          this.loginName = 'HOSPITALITY';
        }
        else if(loginType == this.loginTypes.SKYACCESS_LOGIN) {
          this.loginName = 'SKYACCESS';
        }
        else if(loginType == this.loginTypes.FREELEX_LOGIN) {
          this.loginName = 'FREEFLEX';
        }
        else if(loginType == this.loginTypes.HEALTH_CARE) {
          this.loginName = 'HEALTHCARE';
        }
        else if(loginType == this.loginTypes.HOME_MONITORING) {
          this.loginName = 'HOME MONITORING';
        }
        else if(loginType == this.loginTypes.GREEN_BUILDING) {
          this.loginName = 'GREEN BUILDING';
        }
        else if(loginType == this.loginTypes.PARKING) {
          this.loginName = 'PARKING';
        }
        else if(loginType == this.loginTypes.TIME_ATTENDANCE) {
          this.loginName = 'TIME AND ATTENDANCE';
        }
        else if(loginType == this.loginTypes.EVENT_TICKETING) {
          this.loginName = 'EVENT TICKETING';
        }
        else {
          this.router.navigateByUrl('/');
        }
      }else {
        this.router.navigateByUrl('/');
      }
    });
  }


  onLogin() {
    this.skyAccessLogin.nativeElement.click();
    // if(this.type == LoginType.LOGIN) {
      
    // }
    // else if(this.type == LoginType.ACCESS_CONTROL_LOGIN) {
    //   console.log('access control clicked');
    //   // window.location.href = 'https://www.skyaccess.eu/IACloud-Platform/dashboard/default';
    //   this.accessControlLogin.nativeElement.click();
    // }
    // else if(this.type == LoginType.HOSPITALITY_LOGIN) {
    //   console.log('hospitalicty clicked');
    //   // window.location.href = 'https://www.skyaccess.eu/IACloud-Platform/dashboard/crm';
    //   this.hospitalityLogin.nativeElement.click();
    // }
    // else if(this.type == LoginType.SKYACCESS_LOGIN) {
    //   console.log('skyaccess clicked');
    //   // window.location.href = 'https://www.skyaccess.eu/IACloud-Platform/skyaccess/hotel';
    //   this.skyAccessLogin.nativeElement.click();
    // }
    // else if(this.type == LoginType.FREELEX_LOGIN) {
      
    // }
  }

}
